<template>
  <div>
    <loader v-if="loading||currentProductLoading"></loader>
    <template v-if="!loading&&!currentProductLoading">
      <template v-if="is_product_kind_website">
        <WebsiteProduct />
      </template>
      <template v-else>
        <TopBar :page="topBarData" @menuItemClick="topMenuClicked"/>
        <v-container fluid>
            <RetentionBanner :productId="id" />

            <template v-if="hasEscalations(openEscalations)">
              <template v-for="alert in openEscalations">
                <v-row v-if="alert.status==='escalation'" :key="alert.id">
                  <v-col>
                    <v-alert class="mb-0" type="error"><b>{{alert.creation_timestamp | date}}</b> {{alert.description}}</v-alert>
                  </v-col>
                </v-row>
              </template>
            </template>

            <Details />

            <template v-if="is_product_kind_voip">

              <v-row>
                <v-col v-if="isVoip2" cols="12" md="4">
                  <TariffDetails />
                </v-col>
                <v-col v-if="isVoip2" cols="12" md="2">
                  <Enterprise :displaycLength="displaycLength" :mainNumbers="mainNumbers" :siteInitial="siteInitial" :product="currentProduct" :userLoading="userLoading" :siteForm="siteForm" @open-edit="openSiteF" @open-extend-trial="openExtendTrial=true" :currentVoipSite="currentVoipSite" />
                </v-col>
                <v-col cols="12" md="6">
                  <Notes :id="id" notesType="product">
                    <template #additional-buttons>
                      <v-btn color="secondary" x-small :to="`/products/${id}/histories`" target="_blank"><v-icon small>{{mdiOpenInNew}}</v-icon></v-btn>
                    </template>
                  </Notes>
                </v-col>
              </v-row>

              <template v-if="isVoip2">
                <v-row>
                  <v-col>
                    <Users :siteInitial="siteInitial" :addons="addons" :productChildren="productChildren" :userLoading="productChildrenLoading" :product="currentProduct" :userNumbers="userNumbers" @open-add-user="openAddUserFun" @open-edit-user="(val)=>{openEditUserID(val)}" @open-user-status-history="openUserStatusHistory" :productAllTariffs="productAllTariffs" @user-deleted="triggerUserFetch" @updateDdi="triggerUserFetch"/>
                  </v-col>
                </v-row>
              </template>

              <v-row>
                <v-col cols="12" md="8" >
                  <Numbers :numbersLoading="numbersLoading" />
                </v-col>
                <v-col v-if="isVoip2" cols="12" md="4">
                  <InstallationAddress :currentVoipSite="currentVoipSite" @open-edit-dialog="openInstallAddress=true"/>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="8">
                  <NumberTransfers :numbersLoading="numbersLoading" @newNumberRangeAdded="triggerNumberFetch" />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" :md="isVoip2?5:8">
                  <UpfrontCosts />
                </v-col>
                <v-col v-if="isVoip2" cols="12" md="4">
                  <ProductHardware />
                </v-col>
                <v-col cols="12" :md="isVoip2?3:4">
                  <DeliveryAddress />
                </v-col>
              </v-row>

            </template>

            <template v-else>
              <template>
                <v-row>
                  <v-col cols="12" md="6">
                    <TelcoTariffDetails v-if="isTelco2" />
                    <TelcoTariffV1Details v-else />
                  </v-col>
                  <v-col cols="12" md="6">
                    <Notes :id="id" notesType="product">
                      <template #additional-buttons>
                        <v-btn color="secondary" x-small :to="`/products/${id}/histories`" target="_blank"><v-icon small>{{mdiOpenInNew}}</v-icon></v-btn>
                      </template>
                    </Notes>
                  </v-col>
                </v-row>

                <template v-if="getIsMobileBroadband">
                  <v-row>
                    <v-col cols="12" md="6">
                      <TelcoMobileBBProvisioning />
                    </v-col>
                    <v-col cols="12" md="3">
                      <TelcoMobileBBLine />
                    </v-col>
                    <v-col cols="12" md="3">
                      <Availability />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6">
                      <UpfrontCosts />
                    </v-col>
                    <v-col cols="12" md="3">
                      <DeliveryAddress />
                    </v-col>
                    <v-col cols="12" md="3">
                      <FaultAppointment />
                    </v-col>
                  </v-row>
                </template>

                <template v-else>
                  <v-row>
                    <v-col cols="12" md="6">
                      <TelcoProvisioning />
                    </v-col>
                    <v-col cols="12" md="3">
                      <TelcoLine />
                    </v-col>
                    <v-col cols="12" md="3">
                      <Availability />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6">
                      <UpfrontCosts />
                    </v-col>
                    <v-col cols="12" md="3">
                      <ModemCredentials />
                    </v-col>
                    <v-col cols="12" md="3">
                      <FaultAppointment />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="3">
                      <DeliveryAddress />
                    </v-col>
                  </v-row>
                </template>
              </template>

              <ChangeTariffDialog v-model="telcoChangeTariffOpen" />

            </template>

            

            <v-snackbar v-model="snackbar" bottom :timeout="5000">
              {{snackbar_text}}
              <v-btn :color="snackbar_color" text @click="snackbar = false">Close</v-btn>
            </v-snackbar>

        </v-container>
        <StatusHistoryDialog :product_id="statusHistoryProductId" :dialogOpen="statusHistoryOpen" @close-dialog="statusHistoryOpen=false;" />

        <AddNewUser :dialogOpen="openAddUser" :addUserForm="addUserForm" :addons="addons" :groupedAddons="groupedAddons" :addUserFormLoading="addUserFormLoading" @close-dialog="openAddUser=false" @submit-dialog="addChildProduct"/>

        <EditUser :openDialog="openEditUser" :currentVoipSite="currentVoipSite" :editUserForm="editUserForm" :editUserFormLoading="editUserFormLoading" :addons="addons" :groupedAddons="groupedAddons" @close-dialog="openEditUser=false" @submit-dialog="updateChildProductInner"/>

        <EditInstallationAddress :dialogOpen="openInstallAddress" :address="currentVoipSite.installation_address" :selectedAddress="selectedAddress" @close-dialog="openInstallAddress=false" @submit-dialog="updateInsAddress"/>

        <TransferTelco :telcoTransfer="telcoTransferOpen" @close-transfer="telcoTransferOpen=false;"/>

        <ContractListDialog :dialogOpen="contractListOpen" :product_id="id" @close-dialog="contractListOpen=false;"  />

        <ChangeTariffModal :dialogOpen="openChangeTariff" @close-dialog="openChangeTariff=false" :siteInitial="siteInitial" :productChildren="productChildren" :productID="id" @changeTariffSuccess="changeTariffSuccess"/>

        <CliHistoryDialog :productID="id" :dialogOpen="cliHistoryOpen" @close-dialog="cliHistoryOpen=false"/>

        <CliChangeDialog :product="currentProduct" :dialogOpen="cliChangeOpen" @close-dialog="cliChangeOpen=false"/>

        <AdhocCreateInvoiceDialog @close-dialog="setAdhocCreateInvoiceOpen(false)"/>

        <AdhocHistoryDialog :dialogOpen="adhocHistoryOpen" @close-dialog="adhocHistoryOpen=false"/>

        <LinkAsCot :dialogOpen="linkAsCotOpen" @close-dialog="linkAsCotOpen=false;" />

        <LinkAs :dialogOpen="linkAsOpen" :type="linkAsType" @close-dialog="linkAsOpen=false;" />

        <ModemReplacementDialog :dialogOpen="modemReplacementOpen" @close-dialog="modemReplacementOpen=false;"/>

        <EDBEmail :dialogOpen="edbEmailOpen" @close-dialog="edbEmailOpen=false;" />

        <CreateNewTicket :dialogOpen="newTicketOpen" @close-dialog="newTicketOpen=false;"/>

        <SendSMSPopup :open="sendSMSPopupOpen" :close="() => {sendSMSPopupOpen = false}" :value="sendSMSPopupOpen" :product="currentProduct.id" :account="Number(account.id)" kind="product" :sub_kind="currentProduct.product_kind.toLowerCase()" :phoneNumber="account.mobile_number || account.phone_number " />

        <ProductAuditDialog v-model="productAuditDialogOpen" />

        <SendTrustpilotReviewDialog :open="sendTrustpilotReviewDialogOpen" @close="sendTrustpilotReviewDialogOpen=false"/>
      </template>
    </template>
  </div>
</template>

<script>
  import TopBar from "../components/Layout/TopBar";

  import Enterprise from "../components/Products/Enterprise/Enterprise";
  import TariffDetails from "../components/Products/Tariff/TariffDetails";
  import Loader from "../components/Misc/Loader";
  import Numbers from "../components/Products/Numbers/Numbers";
  import NumberTransfers from "../components/Products/Numbers/NumberTransfers";
  import TransferTelco from "../components/Products/TransferTelco";
  import ContractListDialog from "../components/Products/ContractListDialog";
  import ChangeTariffModal from "../components/Products/ChangeTariffModal";
  import AddNewUser from "../components/Products/AddNewUser";
  import EditUser from "../components/Products/EditUser";
  import EditInstallationAddress from "../components/Products/EditInstallationAddress";
  import InstallationAddress from "../components/Products/InstallationAddress";
  import Users from "../components/Products/Users";
  import ProductHardware from "@/components/Products/ProductHardware/ProductHardware";
  import Provisioning from "../components/Products/Provisioning/Provisioning";

  import ChangeTariffDialog from "../components/Products/ProductTypes/AllProducts/ChangeTariff/ChangeTariffDialog";
  import TelcoProvisioning from "../components/Products/ProductTypes/Telco/Provisioning/TelcoProvisioning";
  import TelcoMobileBBProvisioning from "../components/Products/ProductTypes/Telco/Provisioning/TelcoMobileBBProvisioning";
  import TelcoLine from "../components/Products/ProductTypes/Telco/Provisioning/TelcoLine";
  import TelcoMobileBBLine from "../components/Products/ProductTypes/Telco/Provisioning/TelcoMobileBBLine";
  import TelcoTariffDetails from "../components/Products/ProductTypes/Telco/TelcoTariffDetails";
  import TelcoTariffV1Details from "@/components/Products/ProductTypes/Telco/TelcoTariffV1Details";
  import LinkAsCot from "../components/Products/LinkAsCot/LinkAsCot";

  import Notes from "@/components/Globals/Notes/Notes";
  import StatusHistoryDialog from "../components/Products/ProductTypes/AllProducts/StatusHistoryDialog";
  import Details from "../components/Products/ProductTypes/AllProducts/Details";
  import WebsiteProduct from "../components/Products/ProductTypes/Website/WebsiteProduct";
  import AdhocCreateInvoiceDialog from "../components/Products/ProductTypes/AllProducts/Adhoc/AdhocCreateInvoiceDialog";
  import AdhocHistoryDialog from "../components/Products/ProductTypes/AllProducts/Adhoc/AdhocHistoryDialog";
  import CliHistoryDialog from "../components/Products/ProductTypes/AllProducts/Cli/CliHistoryDialog";
  import CliChangeDialog from "../components/Products/ProductTypes/AllProducts/Cli/CliChangeDialog";
  import UpfrontCosts from "../components/Products/ProductTypes/AllProducts/UpfrontCosts/UpfrontCosts";
  import EDBEmail from "../components/Products/ProductTypes/Telco/EDBEmail";
  import LinkAs from "../components/Products/ProductTypes/Telco/LinkAs";
  import ModemReplacementDialog from "../components/Products/ProductTypes/Telco/ModemReplacementDialog";
  import ModemCredentials from "../components/Products/ProductTypes/Telco/ModemCredentials";
  import Availability from "../components/Products/ProductTypes/Telco/Availability/Availability";
  import FaultAppointment from "../components/Products/ProductTypes/Telco/FaultAppointment/FaultAppointment";

  import CreateNewTicket from "@/components/Tickets/Dialogs/CreateNewTicket";
  import RetentionBanner from "@/components/Products/ProductTypes/AllProducts/RetentionBanner";
  import SendSMSPopup from "@/components/Misc/SendSMSPopup";
  import DeliveryAddress from '@/components/Products/ProductTypes/AllProducts/DeliveryAddress';
  import ProductAuditDialog from '@/components/Products/ProductTypes/AllProducts/ProductAuditDialog';
  import SendTrustpilotReviewDialog from '@/components/Products/ProductTypes/AllProducts/SendTrustpilotReviewDialog';

  import { mapState,mapActions,mapMutations,mapGetters } from "vuex";
  import moment from "moment";
  import { mdiOpenInNew } from '@mdi/js';
  import { links, myBonlineDomain } from '@/helpers/links';

  const QUEUE_URL = process.env.VUE_APP_QUEUE_URL || `https://queues-bonline-testing.appspot.com/`;
  const OLD_CRM_LINK = process.env.VUE_APP_API_HOST || `https://ctst-testing.appspot.com/`;

  export default {
    components: { TariffDetails, Numbers, NumberTransfers,Loader,TransferTelco,TopBar,ContractListDialog,StatusHistoryDialog,ChangeTariffModal,Notes,AddNewUser,EditUser,EditInstallationAddress,InstallationAddress,Users,Enterprise,Details,AdhocCreateInvoiceDialog,AdhocHistoryDialog,UpfrontCosts,Provisioning,ProductHardware,TelcoProvisioning,TelcoMobileBBProvisioning,TelcoLine,TelcoMobileBBLine,TelcoTariffDetails,TelcoTariffV1Details,LinkAsCot,WebsiteProduct,EDBEmail,LinkAs,CliHistoryDialog,CliChangeDialog,ModemReplacementDialog,ModemCredentials,CreateNewTicket,RetentionBanner,Availability,SendSMSPopup,ChangeTariffDialog,FaultAppointment, DeliveryAddress, ProductAuditDialog, SendTrustpilotReviewDialog },
    
    data() {
      return {
        topBarData: {
          name: 'loading...',
          type:'productVoip',
          menu:true,
          showSearch:true,
          breadcrumbs: [
            {
              text: 'Billing Accounts',
              disabled: false,
              href: '/accounts/',
            }
          ],
          showBeehiveIcon: false,
          articleLink: '',
        },
        sendSMSPopupOpen: false,
        statusHistoryOpen: false,
        statusHistoryProductId: null,
        contractListOpen: false,
        userLoading: true,
        snackbar: false,
        snackbar_text: '',
        snackbar_color: '',
        openInstallAddress: false,
        openAddUser: false,
        addUserFormLoading: false,
        addUserForm: {
          quantity: 1,
          tariff: '-',
          cLength: '-',
          promo: '-',
          addons: {},
          totals: {totalNoVat:'',initial:{text:'',value:0},vat:'',total:''},
          totalsQuan: {totalNoVat:'',initial:0,vat:'',total:''},
        },
        openEditUser: false,
        selectedUserToEdit: {},
        editUserFormLoading: false,
        editUserForm: {
          userObj: '',
          id: '',
          tariff: '-',
          cLength: '-',
          promo: {name:'',price:0},
          addons: {},
          totals: {totalNoVat:'',initial:{text:'',value:0},vat:'',total:''},
        },
        openSite: false,
        openSiteLoading: false,
        openExtendTrial: false,
        tariffLoading: false,
        toCrmUrl: OLD_CRM_LINK,
        loading: true,
        id: this.$route.params.id,
        product: {},
        productKind: '',
        account: {},
        linkMapping: {'web': 'sites','voip': 'voip','telco': 'phonelines'},
        siteForm: {
          mainNumber: '',
          tariff: '',
          cLength: '',
          promo: '',
          addons: [],
          internationalCallBarring: null,
          serviceStatus: '',
          trialPeriod: '',
          trialKind: '',
          errors: {tariff:'',cLength:''}
        },
        siteInitial: {mainNumber:'',tariff:{id:'',addons:[],name: '-',price:0,service:''},cLength:'',promo:{id:'',name:'',price:0}, addons: [],trialPeriod:''},
        userNumbers: [],
        mainNumbers: [],
        internationalCallingItems: [{"text": "Disabled", "value": true}, {"text": "Enabled", "value": false}],
        tariffs: [],
        cLengths: [],
        numbersLoading: true,
        promosLoading: false,
        promos: [],
        addons: [],
        groupedAddons: [],
        allProductPromos: [],
        allProductTariffs: [],
        telcoTransferOpen: false,
        changeTariffs: [
          { title: "Change Tariff", value: "changeTariff" }
        ],
        openChangeTariff: false,
        adhocCreateInvoiceOpen: false,
        cliHistoryOpen: false,
        cliChangeOpen: false,
        adhocHistoryOpen: false,
        edbEmailOpen: false,
        linkAsCotOpen: false,
        linkAsOpen: false,
        linkAsType: '',
        modemReplacementOpen: false,
        newTicketOpen: false,
        telcoChangeTariffOpen: false,
        mdiOpenInNew,
        productAuditDialogOpen: false,
        sendTrustpilotReviewDialogOpen: false
      };
    },
    async mounted(){
      this.getLeadByID({id: this.id});
      await this.fetchMainProduct(this.id);
      if(this.currentProduct.account_id!==null){ this.account = this.currentAccount; }
      // =========== NEW API CALLS ============
      this.fetchTariffs(this.currentProduct);
      this.fetchAddons(this.currentProduct);
      this.loadNumberRanges(this.currentProduct.id);
      // =========== NEW API CALLS ============

      this.productKind = this.currentProduct.product_kind.toLowerCase();
      this.topBarData.type = (this.productKind==='voip')?'productVoip':'productTelco';
      if(this.product_kind!=='web'){
        await this.getEscalations(this.id);
        let tarrifV = this.currentProduct.tariff_version.replace('TARIFF_V','');
        if(this.productKind==='voip'){
          const supplier = this.currentProduct.supplier;
          await this.getAndSortNumbers();
          await this.getAllAddons({ version: tarrifV, supplier });
          if(this.isVoip2){
            this.siteInitial.addons = this.filterAddonsSiteDisplay(this.currentProduct.addons,this.voipSiteAddons);
            this.siteForm.addons = this.filterAddonsForm(this.currentProduct.addons,this.voipSiteAddons);
            this.siteForm.trialPeriod = this.currentProduct.trial_period_length_days;
            this.siteForm.trialKind = this.currentProduct.trial_kind;
  
            await this.getAndSortTariffs(tarrifV, supplier);
            this.siteInitial.cLength = this.currentProduct.contract_length_months;
            this.siteInitial.promo = this.findPromoById(this.currentProduct.promo_id);
            this.siteInitial.tariff = this.findTariffById(this.currentProduct.tariff_id);
            this.siteInitial.trialPeriod = this.currentProduct.trial_period_length_days;
            
            await this.sortAllAddons();
            await this.setUserAddons();
            await this.getCurrentVoipSite(this.id);
            this.siteForm.mainNumber = (this.currentVoipSite.pilot_number_id!==null)?this.currentVoipSite.pilot_number_id:'';
            this.siteForm.tariff = this.currentProduct.tariff_id;
            if(this.siteForm.tariff!==null){
              this.changeTariff(false);
              this.siteForm.cLength = this.currentProduct.contract_length_months;
              if(this.siteForm.cLength!==null){
                this.siteForm.promo = this.currentProduct.promo_id;
              }
            }
            this.siteInitial.mainNumber = this.siteForm.mainNumber;
            if(this.currentVoipSite.platform_id) {
              try {
                this.fetchEnterpriseConfiguration(this.currentVoipSite.id);
              } catch(err) {
                this.userLoading = false;
              }
            }
            this.userLoading = false;
          }

          this.topBarData.showBeehiveIcon = true;
          this.topBarData.articleLink = 'productVoip';
        }
      
        let viewingAcc = setInterval(()=>{
          if(this.currentProduct.id!==undefined&&this.account.business_name!==undefined&&this.productKind!==undefined&&this.currentProduct.status!==undefined){
            this.topBarData.name = `${this.account.id} - ${this.account.business_name}`;
            this.topBarData.breadcrumbs.push(
              {text:this.topBarData.name,disabled:false,href:`/accounts/${this.account.id}/`},
              {text:'Product',disabled:true,href:`#`},
              {text:this.currentProduct.id,disabled:true,href:`#`},
            );
            this.addRecentlyViewed({
              id: this.currentProduct.id,
              name: this.account.business_name,
              type: this.productKind.toLowerCase(),
              status: this.currentProduct.status,
              datetime: new Date()
            });
            clearInterval(viewingAcc);
          }
        },500);
        setTimeout(()=>{
          if(this.account.business_name===undefined){
            this.topBarData.name = `New Customer`;
            this.topBarData.breadcrumbs.push(
              {text:'Product',disabled:true,href:`#`},
              {text:this.currentProduct.id,disabled:true,href:`#`},
            );
            this.addRecentlyViewed({
              id: this.currentProduct.id,
              name: this.topBarData.name,
              type: this.productKind.toLowerCase(),
              status: this.currentProduct.status,
              datetime: new Date()
            });
            clearInterval(viewingAcc);
          }
        },2500);
      }

      this.loading = false;
    },
    computed: {
      ...mapState("products", ["selectedTariffPromos","currentProduct","currentProductLoading","productNumbers","productAvailableTariffs","productAllTariffs","productAllPromos","currentVoipSite","productChildren","productChildrenLoading","productAddons", "voipSiteAddons","openEscalations"]),
      ...mapState("accounts", ["currentAccount"]),
      ...mapState("globals", ["selectedAddress"]),
      ...mapGetters("enterpriseConfiguration", ["getHasInternationalCallsInEdit"]),
      ...mapGetters("productLinks", ["getLinkedProducts"]),
      ...mapGetters('comms', ['getContacts', 'getContactsError']),
      ...mapGetters('globals',['hasUserGotRole']),
      ...mapGetters('leads', ['getCurrentLead']),
      ...mapGetters('productTelco',['getTelcoTariffByID', 'getTelcoTariffsLoading', 'getIsMobileBroadband']),

      product_kind(){
        if(Object.keys(this.currentProduct).length <= 0) return false;
        return this.productKind.toLowerCase();
      },
      is_product_kind_voip(){
        if(Object.keys(this.currentProduct).length <= 0) return false;
        return this.productKind.toLowerCase()==='voip';
      },
      is_product_kind_telco(){
        if(Object.keys(this.currentProduct).length <= 0) return false;
        return this.productKind.toLowerCase()==='telco';
      },
      is_product_kind_website(){
        if(Object.keys(this.currentProduct).length <= 0) return false;
        return this.productKind.toLowerCase()==='web';
      },
      isTelco() {
        if(Object.keys(this.currentProduct).length <= 0) return false;
        return this.productKind.toLowerCase() === 'telco';
      },
      isTelco2() {
        if(Object.keys(this.currentProduct).length <= 0) return false;
        return this.productKind.toLowerCase() === 'telco' && this.currentProduct.tariff_version.toLowerCase() === "tariff_v2";
      },
      isVoip2() {
        let ret = false;
        if(this.currentProduct.tariff_version!==undefined&&this.currentProduct.supplier!==undefined){
          ret = this.currentProduct.tariff_version.toLowerCase() === "tariff_v3" && (this.currentProduct.supplier.toLowerCase() === "centile" || this.currentProduct.supplier.toLowerCase() === "voip3");
        }
        return ret;
      },
      displaycLength(){
        const pThis = this;
        let cLength = '-';
        if(pThis.siteInitial.cLength!==''&&pThis.siteInitial.cLength!==null){
          return `${pThis.siteInitial.cLength} Months`;
        }
        return cLength;
      },
      isMobileBB(){
        return (this.getTelcoTariffByID.service !== undefined && this.getTelcoTariffByID.service === '5G');
      }
    },
    methods: {
      ...mapActions('productGeneral', ['fetchTariffs','fetchAddons']),
      
      ...mapActions("enterpriseConfiguration", ["fetchEnterpriseConfiguration", "updateEnterpriseConfiguration"]),
      ...mapActions("alerts", ["setAlert"]),
      ...mapActions('numbers', ['loadNumberRanges']),
      ...mapActions('comms', ['fetchContacts']),
      ...mapMutations('adhoc',['setAdhocCreateInvoiceOpen']),
      ...mapMutations('changeTariff',['set_productKind','set_changeTariffProduct']),

      goToEscalation(pid){ window.open(`${this.toCrmUrl}voip/a/${pid}`); },
      hasEscalations(tickets){
        let ret = false;
        tickets.forEach(ticket => {
          if(!ret&&ticket.status==='escalation'){ ret = true; }
        });
        return ret;
      },
      topMenuClicked(menuItem){
        switch(menuItem){
          case 'linkAsCot':
            const voipCotLinks = this.getLinkedProducts.filter(e=>e.link_type==='COT');
            if(!voipCotLinks[0]){
              this.linkAsCotOpen = true;
            }else{
              const hasCotLinkTo = voipCotLinks.filter(e=>e.product_1_id===this.currentProduct.id).length;
              if(hasCotLinkTo){
                this.setAlert({type: 'error', message: `There is already an existing COT for this product`});
              }else{
                this.linkAsCotOpen = true;
              }
            }
            break;
          case 'hardwareOrderingQueue':
            window.open(`${QUEUE_URL}hardware-ordering/actions/?account_id=${this.currentAccount.id}`);
            break;
          case 'newTicket':
            this.newTicketOpen = true;
            break;
          case 'ticketsPage':
            this.$router.push(`/tickets?product_id=${this.$route.params.id}`);
            break;
          case 'cliHistory':
            this.cliHistoryOpen = true;
            break;
          case 'changeCli':
            this.cliChangeOpen = true;
            break;
          case 'adhocHistory':
            this.adhocHistoryOpen = true;
            break;
          case 'adhocCreateInvoice':
            this.setAdhocCreateInvoiceOpen(true);
            break;
          case 'contractList':
            this.contractListOpen = true;
            break;
          case 'statusHistory':
            this.statusHistoryProductId = this.id;
            this.statusHistoryOpen = true;
            break;
          case 'changeTariff':
            this.openChangeTariff = true;
            break;
          case 'portToVoip':
            const transferLinks = this.getLinkedProducts.filter(e=>e.link_type==='INTERNAL_TRANSFER');
            if(!transferLinks[0]){
              this.telcoTransferOpen = true;
            }else{
              const hasCotLinkTo = transferLinks.filter(e=>e.product_1_id===this.currentProduct.id).length;
              if(hasCotLinkTo){
                this.setAlert({type: 'error', message: `There is already an existing Internal transfer for this product`});
              }else{
                this.telcoTransferOpen = true;
              }
            }
            break;
          case 'modemReplacement':
            this.modemReplacementOpen = true;
            break;
          case 'edbEmail':
            this.edbEmailOpen = true;
            break;
          case 'createCOT':
            this.linkAsType = 'COT';
            const cotLinks = this.getLinkedProducts.filter(e=>e.link_type==='COT');
            if(!cotLinks[0]){
              this.linkAsOpen = true;
            }else{
              const hasCotLinkTo = cotLinks.filter(e=>e.product_1_id===this.currentProduct.id).length;
              if(hasCotLinkTo){
                this.setAlert({type: 'error', message: `There is already an existing COT for this product`});
              }else{
                this.linkAsOpen = true;
              }
            }
            break;
          case 'createCOP':
            this.linkAsType = 'COP';
            const copLinks = this.getLinkedProducts.filter(e=>e.link_type==='COP');
            if(!copLinks[0]){
              this.linkAsOpen = true;
            }else{
              const hasCopLinkTo = copLinks.filter(e=>e.product_1_id===this.currentProduct.id).length;
              if(hasCopLinkTo){
                this.setAlert({type: 'error', message: `There is already an existing COP for this product`});
              }else{
                this.linkAsOpen = true;
              }
            }
            break;
          case 'viewOnOldCrm':
            window.open(`${this.toCrmUrl}${this.linkMapping[this.productKind.toLowerCase()]}/search?query=${this.currentProduct.id}`);
            break;
          case "sendSMS":
            this.sendSMSPopupOpen = true;
            break;
          case 'changeTelcoTariff':
            if(this.currentProduct.tariff_version==='TARIFF_V1'){
              window.open(`${this.toCrmUrl}accounts/edit/${this.currentAccount.id}`);
            }else{
              this.set_productKind('telco');
              this.set_changeTariffProduct(this.currentProduct);
              this.telcoChangeTariffOpen = true;
            }
            break;
          case 'legacyTelcoTariff':
            window.open(`${this.toCrmUrl}accounts/edit/${this.currentAccount.id}`);
            break;
          case 'goToLead':
            this.$router.push(`/leads/${this.$route.params.id}/`);
            break;
          case 'audit':
            this.productAuditDialogOpen = true;
            break;
          case 'comms':
            this.goToComms();
            break;
          case 'sendTrustpilotEmail':
            this.openSendTrustpilotReviewDialog();
            break;
          case 'legacyChangeTariffVoip':
            window.open(`${this.toCrmUrl}accounts/edit/${this.currentAccount.id}`);
            break;
          case 'availabilityChecker':
            window.open(process.env.VUE_APP_MY_BONLINE_DOMAIN ? `${process.env.VUE_APP_MY_BONLINE_DOMAIN}broadband-availability` : links.availabilityCheckerTesting);
            break;
          case 'openCustomerPortal':
            if (this.hasUserGotRole('can-access-cp-as-admin')) {
              window.open(`${myBonlineDomain}loginas/?email=${encodeURIComponent(this.getCurrentLead.contact.email_address)}`);
            } else {
              this.setAlert({type: 'error', message: 'You do not have the permission to perform this action.'});
            }
            break;
        }
      },

      async goToComms() {
        const data = {type: 'product', id: this.currentProduct.id};
        await this.fetchContacts(data);

        if (!this.getContactsError) {
          const emails = [...new Set(this.getContacts.filter(contact => contact.email_address).map(contact => contact.email_address))];
          const phone_numbers = [...new Set(this.getContacts.filter(contact => contact.phone_number).map(contact => contact.phone_number))];
          const mobile_numbers = [...new Set(this.getContacts.filter(contact => contact.mobile_number).map(contact => contact.mobile_number))];
          const numbers = [...new Set(phone_numbers.concat(mobile_numbers))];

          localStorage.setItem('comms_emails', JSON.stringify(emails));
          localStorage.setItem('comms_numbers', JSON.stringify(numbers));

          window.open('/comms/');
        }
      },

      async triggerUserFetch(){
        this.userLoading = true;
        await this.setChildren();
        await this.getAndSortNumbers();
        this.userLoading = false;
      },
      async triggerNumberFetch(){
        this.numbersLoading = true;
        await this.getProductById(this.id);
        await this.getAndSortNumbers();
        let tarrifV = this.currentProduct.tariff_version.replace('TARIFF_V','');
        const supplier = this.currentProduct.supplier;
        await this.getAllAddons({ version: tarrifV, supplier});
        this.siteInitial.addons = this.filterAddonsSiteDisplay(this.currentProduct.addons,this.voipSiteAddons);
        this.siteForm.addons = this.filterAddonsForm(this.currentProduct.addons,this.voipSiteAddons);
        await this.loadNumberRanges(this.id);
        this.numbersLoading = false;
      },
      async ctUpdateSiteTariff(tariff,length,promo){
        this.siteInitial.tariff = this.findTariffById(tariff);
        this.siteInitial.cLength = parseInt(length);
        this.siteInitial.promo = this.findPromoById(promo);
      },
      async ctUpdateSiteAddons(data){
        let addons = [];
        Object.keys(data).forEach(key => {
          let add = data[key];
          if(add.allow_quantity){
            if(add.quantity>0){addons.push({addon_id:add.id,name:add.name,quantity:add.quantity});}
          }else{
            if(add.selected){addons.push({addon_id:add.id,name:add.name,quantity:1});}
          }
        });
        this.siteInitial.addons = addons;
      },
      constructUsersObj(users){
        let obj = {};
        users.forEach(user => {
          let addons = [];
          Object.keys(user.addons).forEach(key => {
            let group = user.addons[key];
            group.items.forEach(add => {
              if(add.selected){
                addons.push({addon_id:add.id,quantity:1});
              }
            });
          });
          obj[user.id] = addons;
        });
        return obj;
      },
      async ctUpdateUserAddons(data){
        let usersAddons = this.constructUsersObj(data);
        this.productChildren.forEach(child => {
          child.addons = usersAddons[child.id];
        });
      },
      async changeTariffSuccess(payload){
        let data = payload.data;
        if(data.changeReason==='CHANGE_ADD_ONS'){
          await this.ctUpdateSiteAddons(data.siteAddons);
          await this.setUserAddons();
        } else {
          await this.ctUpdateSiteTariff(data.tariff.id,data.cLength,data.promo.id);
          await this.ctUpdateSiteAddons(data.siteAddons);
          await this.setUserAddons();
        }
        this.openChangeTariff = false;
      },
      checkNegative(item,i){
        if(this.siteForm.addons[i].quantity<0){
          return this.siteForm.addons[i].quantity = 0;
        }
      },
      filterAddonsSiteDisplay(productAddons,availableAddons) {
        return productAddons.map(e=>{
          return {productAddons: e,availableAddons: availableAddons.find(({id})=>id===e.addon_id),}
        })
        .map(e=>({addon_id: e.productAddons.addon_id, name: e.availableAddons.name, price: e.availableAddons.standard_price, quantity: e.productAddons.quantity,}));
      },
      updateAddonsSiteDisplay(siteInitial,siteForm){
        const site = [];
        siteForm.forEach(j=>{
          if(j.quantity>0){
            site.push({addon_id: j.addon_id, name: j.name, quantity: j.quantity,price: j.price});
          }
        });
        return site;
      },
      filterAddonsForm(productAddons,availableAddons){
        return availableAddons.map(e=>({
          ...productAddons.find(({addon_id})=>addon_id===e.id),
          ...e,
        }))
        .map(e=>({
          addon_id: e.id, 
          name: e.name, 
          allow_quantity: e.allow_quantity, 
          price: e.standard_price,
          quantity: e.quantity||0, 
          available: e.available,
          display_group: e.display_group,
        }));
      },
      filterAddonsUpdate(){
        return this.siteForm.addons.filter(e=>e.quantity>0).map(e=>({addon_id: e.addon_id, quantity: e.quantity,}));
      },
      disableIfNotStatus(exceptions, allowed){
        let pStatus = this.currentProduct.status.toLowerCase();
        if(exceptions!==undefined){
          return exceptions.indexOf(pStatus)!==-1;
        }
        if(!Array.isArray(allowed)) {
          allowed = [];
        }
        let statusCanEdit = ["warm","index","inbound", "for approval","verification","provisioning failed"].concat(allowed);
        return (statusCanEdit.indexOf(pStatus)===-1);
      },
      singleUserAddonIncluded(add){
        return (this.addUserForm.addons[`ad_${add.id}`].included)?`Included`:`+£${add.price}`;
      },
      addChildProduct(){
        this.addUserFormLoading = true;
        let quantity = parseInt(this.addUserForm.quantity);
        let addons = [];
        Object.keys(this.addUserForm.addons).forEach(k=>{
          let add = this.addUserForm.addons[k];
          let id = k.replace('ad_','');
          if(add.switched){
            addons.push({addon_id:parseInt(id)});
          }
        });
        this.createProductChildren({
          id: this.currentProduct.id,
          data: Array(quantity).fill({
            product_kind: 'VOIPSEAT',
            contract_length_months: this.currentProduct.contract_length_months,
            parent_product_id: this.currentProduct.id,
            tariff_id: this.currentProduct.tariff_id,
            promo_id: this.currentProduct.promo_id,
          }),
        }).then(res => {
          let addCalls = [];
          res.data.forEach(product => {
            let id = product.id;
            addCalls.push(this.updateProduct({id:id,data:{addons:addons}}));
          });
          let errors = 0;
          Promise.all(addCalls).then(async (response)=>{
            response.forEach(resp=>{
              if(resp.status!==200){ errors++; }
            });
            if(errors===0){
              await this.setChildren();
              await this.getAndSortNumbers();
              this.addUserFormLoading = false;
              this.openAddUser = false;
              this.addUserForm = {quantity:1,tariff:{name:'',price:0},cLength:'-',promo:{name:'',price:0},addons:{},totals:{totalNoVat:'',initial:{text:'',value:0},vat:'',total:''},totalsQuan:{totalNoVat:'',initial:0,vat:'',total:''}};
            
              setTimeout(()=>{
                window.location.reload();
              },500);         
            }
          });
        }).catch(err => {
          this.addUserFormLoading = false;
          this.setAlert({type: 'error', message: err.response.data.message});
        });
      },
      async getAndSortNumbers(){
        this.numbersLoading = true;
        await this.fetchProductNumbers(this.id);
        let nums = [];
        let userNums = [];
        this.productNumbers.forEach((num)=>{
          if(num.extension==='Not Assigned' || num.extension==='Pilot Number' || num.extension==='Main Number'){ nums.push({text:`${num.number}`, value:num.id});  }
          if(num.extension==='Not Assigned'){ userNums.push({text:`${num.number}`, value:num.id}); }
          if(num.extension==='Pilot Number'){ num.extension = 'Main Number'; }
        });
        this.mainNumbers = nums;
        this.userNumbers = userNums;
        this.numbersLoading = false;
      },
      async updateChildProductInner(){
        this.editUserFormLoading = true;
        let addons = [];

        Object.keys(this.editUserForm.addons).forEach(addi=>{
          let add = this.editUserForm.addons[addi];
          if(add.switched&&!add.included){
            addons.push({addon_id: parseInt(addi.replace('ad_',''))});
          }
        });

        await this.updateProduct({id:this.editUserForm.id,data:{addons:addons}});
        await this.setChildren();
        await this.getAndSortNumbers();

        this.editUserFormLoading = false;
        this.openEditUser = false;
        this.editUserForm = { id:'',tariff:'-',cLength:'-',promo:{name:'',price:0},addons:{},totals:{totalNoVat:'',initial:{text:'',value:0,},vat:'',total:'',} };
        this.selectedUserToEdit = {};
      },
      checkEditPrice(type){
        let form = (type==='edit')?this.editUserForm:this.addUserForm;
        let tariff = form.tariff.price;
        let thePromo = form.promo;
        let adds = form.addons;
        let total = 0;
        let initial = {text:'',value:0};
        if(thePromo!==undefined && thePromo.price!==0){
          total = thePromo.price;
          initial.text = 'Promo';
        }else if(tariff!==undefined){
          total = parseInt(tariff);
          initial.text = 'Tariff';
        }
        initial.value = total.toFixed(2);
        Object.keys(adds).forEach(k=>{
          let ad = adds[k];
          if(ad.switched){
            total += ad.price;
          }
        });
        form.totals.totalNoVat = total.toFixed(2);
        form.totals.initial = initial;
        form.totals.vat = (total * 0.2).toFixed(2);
        form.totals.total = (total * 1.2).toFixed(2);
        if(type==='add'){
          let quan = parseInt(form.quantity);
          form.totalsQuan.totalNoVat = (form.totals.totalNoVat * quan).toFixed(2);
          form.totalsQuan.initial = (form.totals.initial.value * quan).toFixed(2);
          form.totalsQuan.vat = (form.totals.vat * quan).toFixed(2);
          form.totalsQuan.total = (form.totals.total * quan).toFixed(2);
        }
      },
      async openAddUserFun(){
        await this.sortAllAddons();
        this.productAllTariffs.forEach(tar=>{
          if(this.siteInitial.tariff.id==tar.id){
            this.addUserForm.tariff = {
              name: tar.name,
              price: tar.standard_price,
            };
          }
        });
        let includedAddons = [];
        let includedGroupedAddons = {};
        this.siteInitial.tariff.addons.forEach(add=>{
          if(add.display_group!==null&&this.groupedAddons[add.display_group]!==undefined){
            if(includedGroupedAddons[add.display_group]===undefined){includedGroupedAddons[add.display_group]=[];}
            includedGroupedAddons[add.display_group].push(add.id);
          }else{
            includedAddons.push(add.id);
          }
        });
        this.addUserForm.cLength = this.displaycLength;
        this.addUserForm.promo = this.siteInitial.promo;
        Object.keys(this.addons).forEach(k=>{
          let addon = this.addons[k];
          this.addUserForm.addons[`ad_${k}`] = {
            switched: (addon.name==='Fraud Protection')?true:false,
            included: ((includedAddons.indexOf(parseInt(k))!==-1) || (includedGroupedAddons[addon.display_group]!==undefined && includedGroupedAddons[addon.display_group].indexOf(parseInt(k))!==-1)),
            price: parseFloat(this.addons[k].price),
          };
        });
        Object.keys(this.groupedAddons).forEach(k=>{
          let group = this.groupedAddons[k];
          group.items.reverse();
          let prevItemIncluded = false;
          let inclGA = includedGroupedAddons[k];
          group.items.forEach((item,ind) => {
            item.disabled = true;
            if(inclGA===undefined){ item.disabled = false; }
            if(inclGA!==undefined && (prevItemIncluded || inclGA.indexOf(item.id)!==-1)){
              if(item.name==='None'){ group.items.splice(ind,1); }
              prevItemIncluded = true;
              item.disabled = false;
              if(inclGA.indexOf(item.id)!==-1){
                group.selected = item.id;
                group.price = item.price;
              }
            }
          });
          group.items.reverse();
        });
        this.checkEditPrice('add');
        this.openAddUser = true;
      },
      async openUserStatusHistory(user){
        this.statusHistoryProductId=user.id;
        this.statusHistoryOpen=true;
      },

      async openEditUserID(user){
        await this.sortAllAddons();
        this.selectedUserToEdit = user;
        this.editUserForm.userObj = user;
        this.editUserForm.id = user.id;
        this.editUserForm.cLength = user.contract_length_months ? `${user.contract_length_months} Months` : '-';
        this.editUserForm.tariff = this.findTariffById(user.tariff_id);
        this.editUserForm.promo = this.findPromoById(user.promo_id);
        let includedAddons = [];
        let includedGroupedAddons = {};

        this.editUserForm.tariff.addons.forEach(add=>{
          if(add.display_group!==null&&this.groupedAddons[add.display_group]!==undefined){
            if(includedGroupedAddons[add.display_group]===undefined){includedGroupedAddons[add.display_group]=[];}
            includedGroupedAddons[add.display_group].push(add.id);
          }else{
            includedAddons.push(add.id);
          }
        });
        Object.keys(this.addons).forEach(k=>{
          let switched = false;
          user.addons.forEach(add=>{
            if(parseInt(k)===add.addon_id){
              switched = (includedAddons.indexOf(parseInt(k))===-1);
            }
          });
          let addon = this.addons[k];
          this.editUserForm.addons[`ad_${k}`] = {
            switched: switched,
            included: ((includedAddons.indexOf(parseInt(k))!==-1) || (includedGroupedAddons[addon.display_group]!==undefined && includedGroupedAddons[addon.display_group].indexOf(parseInt(k))!==-1)),
            price: parseFloat(this.addons[k].price),
            display_group: this.addons[k].display_group,
            id: this.addons[k].id,
          };
        });
        Object.keys(this.editUserForm.addons).forEach(key => {
          let add = this.editUserForm.addons[key];
          if(this.groupedAddons[add.display_group] && add.switched && add.display_group !== undefined){
            this.groupedAddons[add.display_group].selected = add.id;
            this.groupedAddons[add.display_group].price = add.price;
          }
        });
        Object.keys(this.groupedAddons).forEach(k=>{
          let group = this.groupedAddons[k];
          group.items.reverse();
          let prevItemIncluded = false;
          let inclGA = includedGroupedAddons[k];
          group.items.forEach((item,ind) => {
            item.disabled = true;
            if(inclGA===undefined){ item.disabled = false; }
            if(inclGA!==undefined && (prevItemIncluded || inclGA.indexOf(item.id)!==-1)){
              if(item.name==='None'){group.items.splice(ind,1);}
              prevItemIncluded = true;
              item.disabled = false;
            }
          });
          group.items.reverse();
        });
        this.checkEditPrice('edit');
        this.openEditUser = true;
      },
      isIncludedAddon(id,addons){
        let adds = addons.map((add=>{return add.id;}));
        return adds.indexOf(id)!==-1;
      },
      async sortAllAddons(){
        let addons = {};
        let addonGroups = {};
        let groupedAddons = {};

        this.productAddons.forEach(add => {
          if(add.display_group!==null){
            addonGroups[add.display_group] = (addonGroups[add.display_group]!==undefined)?addonGroups[add.display_group]:0;
            addonGroups[add.display_group]++;
          }
        });

        this.productAddons.forEach(v=>{
          if(v.product_kind.toLowerCase()==='voipseat' && (v.available || this.isIncludedAddon(v.id,this.siteInitial.tariff.addons))){
            let preObject = {
              id: v.id,
              name: v.name,
              price: v.standard_price,
              selectable: v.available,
              display_group: v.display_group,
              group_rank: v.group_rank,
              is_type_select: (addonGroups[v.display_group]!==undefined&&addonGroups[v.display_group]>=2),
              disabled: false
            };
            if((addonGroups[v.display_group]!==undefined&&addonGroups[v.display_group]!=='')&&addonGroups[v.display_group]>=2){
              if(groupedAddons[v.display_group]===undefined){ groupedAddons[v.display_group] = {
                name: this.titleCase(v.display_group.replace(/_/g,' ')),
                selected: '',
                price: '-',
                items: [{name:'None',id:'-'}],
              }; }
              groupedAddons[v.display_group].items.push(preObject);
            }
            addons[v.id] = preObject;
          }
        });

        Object.keys(groupedAddons).forEach(k => {
          let group = groupedAddons[k];
          group.items = group.items.sort(function(a,b){return b['group_rank']-a['group_rank']});
        });

        this.addons = addons;
        this.groupedAddons = groupedAddons;
      },
      titleCase(str) {
        if(str===''){ return ''; }
        return str.toLowerCase().split(' ').map(function(word) {
          return word.replace(word[0], word[0].toUpperCase());
        }).join(' ');
      },
      async setChildren(){
        await this.getProductById(this.id);
        await this.setUserAddons();
      },
      async setUserAddons(){
        await this.getProductChildren(this.id);
        this.productChildren.forEach(user=>{
          this.tariffs.forEach(tar=>{
            if(tar.value===user.tariff_id){
              tar.addons.forEach(add=>{
                user.addons.push({addon_id: add.id});
              });
            }
          });
        });
      },
      ...mapActions("products", [
        "getProductById",
        "fetchMainProduct",
        "getProductChildren",
        "fetchProductNumbers",
        "getAllAddons",
        "getAllTariffs",
        "getPromosForTariff",
        "getSubVoipSite",
        "getCurrentVoipSite",
        "updateInstallAddress",
        "createProductChildren",
        "updateProduct",
        "updateChildProductNumber",
        "updateSiteAc",
        "getEscalations",
      ]),
      ...mapActions("accounts", ["getCurrentAccount"]),
      ...mapActions('globals', ['addRecentlyViewed']),
      ...mapActions('leads',['getLeadByID']),

      goToBilling() { this.$router.push(`/accounts/${this.account.id}/`); },
      hideIfNull(item){ return item!==null; },
      dateFormat(date){
        return (date!==null)?moment(date).format('YYYY-MM-DD'):'-';
      },
      findPromoById(id){
        return (id===null||id===undefined)?{id:'',name: '-',price:0}:this.allProductPromos[id];
      },
      findTariffById(id){
        return (id===null||id===undefined||this.allProductTariffs[id]===undefined)?{id:'',addons:[],name: '-',price:0,cLength:[]}:this.allProductTariffs[id];
      },
      findContractLengths(length){
        let lengths = [1,12,18,24,36,48];
        let ind = lengths.indexOf(length);
        lengths = lengths.splice(ind);
        let allLengths = [];
        lengths.forEach(len=>{
          let preLen = {
            text: `${(len===1)?'Month to Month':len+' Months'}`,
            value: len,
          }
          allLengths.push(preLen);
        });
        return allLengths;
      },
      async getAndSortTariffs(tariffV, supplier){
        await this.getAllTariffs({ version: tariffV, supplier });
        let tariffs = {};
        let tariffList = [];
        let promos = [];
        this.productAllTariffs.forEach((tar)=>{
          if(tar.product_kind.toLowerCase()==='voipseat'){
            tariffs[tar.id] = {
              id: tar.id,
              name: tar.name,
              promos: tar.promos,
              price: parseFloat(tar.standard_price),
              addons: tar.addons,
              cLength: this.findContractLengths(tar.min_contract_length_months),
              service: tar.service,
              required_charges: tar.required_charges,
              included_child_charges: tar.included_child_charges,
            };
            tariffList.push({
              text: tar.name,
              promos: tar.promos,
              value: tar.id,
              addons: tar.addons,
              category: tar.category,
              available: tar.available,
            });
            tar.promos.forEach(pro => {
              promos.push(pro.promo);
            });
          }
        });
        
        let allPromos = {};
        promos.forEach((pro)=>{
          allPromos[pro.id] = {
            id: pro.id,
            name: pro.name,
            price: parseFloat(pro.price)
          };
        });
        this.allProductPromos = allPromos;
        this.tariffs = tariffList;
        this.allProductTariffs = tariffs;
      },
      async openSiteF(){
        const supplier = this.currentProduct.supplier;
        let tarrifV = this.currentProduct.tariff_version.replace('TARIFF_V','');
        let promises = [];
        this.openSite = true;
        if(this.tariffs.length===0){
          this.tariffLoading = true;
           promises.push(this.getAndSortTariffs(tarrifV, supplier));
        }
        Promise.all(promises).then(() => {
          this.tariffLoading = false;
        });
      },
      changeTariff(reset){
        this.cLengths = [];
        this.promos = [];
        this.cLengths = this.findTariffById(this.siteForm.tariff).cLength;
        this.siteForm.errors.tariff = '';
        this.siteForm.errors.cLength = '';
        if(reset){
          this.siteForm.cLength = '';
          this.siteForm.promo = null;
        }
      },
      async changecLength(reset){
        this.promosLoading = true;
        const tariff = this.findTariffById(this.siteForm.tariff);
        const promos = tariff.promos.filter(e=> e.available && e.promo.min_contract_length_months<=parseInt(this.siteForm.cLength) ).map(e=>({
          text: e.promo.name,
          value: e.promo.id,
        }));
        const allPromos = [{text: 'No Promo',value: null}].concat(promos);
        
        this.siteForm.errors.cLength = '';
        this.promos = allPromos;
        this.promosLoading = false;
        if(reset){
          this.siteForm.promo = null;
        }
      },
      disabledBeforeSold(){
        let isNotSold = this.currentProduct.sold_date===null;
        let forApproval = this.currentProduct.status==='For Approval';
        return (isNotSold&&forApproval);
      },
      async updateSite(){
        let err = false;
        if(this.siteForm.tariff===''){ this.siteForm.errors.tariff = 'Please select a Tariff'; err = true; }
        if(this.siteForm.cLength===''){ this.siteForm.errors.cLength = 'Please select a Contract Length'; err = true; }
        if(!err){
          let data = {
            mainNumber: (this.siteForm.mainNumber!==''&&this.siteForm.mainNumber!==this.siteInitial.mainNumber)?parseInt(this.siteForm.mainNumber):false,
            tariff: (this.siteForm.tariff!==''&&this.siteForm.tariff!==this.siteInitial.tariff.id)?parseInt(this.siteForm.tariff):false,
            cLength: (this.siteForm.cLength!==''&&this.siteForm.cLength!==this.siteInitial.cLength)?parseInt(this.siteForm.cLength):false,
            promo: this.siteForm.promo,
            addons: (this.siteForm.addons!==null)?this.filterAddonsUpdate():false,
            trial_period_length_days: false,
            trial_kind: this.siteForm.trialKind
          }
          if(this.disabledBeforeSold){ data.trial_period_length_days = (this.siteForm.trialPeriod!==null)?this.siteForm.trialPeriod:false; }
          try {
            this.openSiteLoading = true;
            let success = await this.updateSiteAc({id:this.id,data:data});
            if(success){
              if(this.currentVoipSite.platform_id) {
                let enterpriseConfigurationData = { call_restriction: this.siteForm.serviceStatus };
                if (!this.getHasInternationalCallsInEdit) {
                  enterpriseConfigurationData.international_call_barring = this.siteForm.internationalCallBarring;
                }
                try {
                  await this.updateEnterpriseConfiguration({ id: this.currentVoipSite.id, data: enterpriseConfigurationData});
                  this.setAlert({type: "success",message: 'Enterprise updated successfully! Reloading.'});
                  this.openSiteLoading = false;
                  this.openSite = false;
                  window.location.reload();
                } catch(err) {
                  this.openSiteLoading = false;
                  this.setAlert({type: "error",message: 'Something went wrong, please try again later!'});
                }
              }else{
                this.setAlert({type: "success",message: 'Enterprise updated successfully! Reloading.'});
                this.openSiteLoading = false;
                this.openSite = false;
                window.location.reload();
              }
            } else {
              this.openSiteLoading = false;
              throw success;
            }
          } catch (err) {
            this.openSiteLoading = false;
          }
        }
      },
      async updateInsAddress(){
        await this.updateInstallAddress({id:this.id,data:this.selectedAddress});
        this.openInstallAddress = false;
      },

      openSendTrustpilotReviewDialog() {
        if (!this.currentProduct.account_id) {
          this.setAlert({type: 'error', message: 'Unable to send Trustpilot review: Please link a billing account to the product first'});
          return;
        }

        let trustpilotReviewSent = false;
        if (this.currentAccount.last_trustpilot_review) {
          const date = moment(new Date());
          trustpilotReviewSent =  date.diff(moment(this.currentAccount.last_trustpilot_review), 'days') <= 7;
        }

        if (trustpilotReviewSent) {
          this.setAlert({type: 'error', message: 'Sorry, a review cannot be submitted as one was already submitted on Trustpilot within the last 7 days.'});
        } else {
          this.sendTrustpilotReviewDialogOpen = true;
        }
      }
    },
    filters: {
      formatPrice: (val=>{
        return parseFloat(val).toFixed(2);
      }),
      date: (val=>{
        return moment(val).format('YYYY-MM-DD HH:mm');
      }),
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep .notes__list {
    max-height: 400px;
  }
</style>
